import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import fetchMethodRequest from "../../../../config/service";
import { useNavigate } from "react-router";
import config from "../../../../config/config";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

export default function PriceChangeTracker() {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [showHeadingDialog, setShowHeadingDialog] = useState(false);
  const uploadUrl = "/uploads/csvUpload?type=priceTracker";
  const navigate = useNavigate();

  // SINGLE FILE UPLOAD
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    event.target.value = null; // Reset input

    try {
      const toastId = showToasterMessage(`Processing file...`, "loading");

      const formData = new FormData();
      formData.append("file", file);
      const response = await fetchMethodRequest("POST", uploadUrl, formData);

      if (response && response.respMessage) {
        setTimeout(() => {
          toast.update("loader-toast", {
            render: `File processed successfully!`,
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        }, 300);
      } else {
        throw new Error("Processing failed");
      }
    } catch (err) {
      console.error("Single-file upload error:", err);
      toast.update("loader-toast", {
        render: "Failed to process file. Please try again.",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const handleUploadButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleDownload = () => {
    const url = `${config.imgUrl}server/upload/reports/price_changes.xlsx`;
    console.log(url)
    const link = document.createElement("a");
    link.href = url;
    link.download = "price_changes.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <div className="container mt-5">
      <div className="container-fluid py-4 files-analysis-container">
        <div className="d-flex justify-content-center align-items-center min-vh-75">
           <Dialog
                    header="Tracking Customer Surveillance — Details"
                    visible={showHeadingDialog}
                    style={{ width: "60vw" }}
                    onHide={() => setShowHeadingDialog(false)}
                  >
                    <div style={styles.headingDialogText}>
                     <p><strong>Tracking #:</strong> 14</p>
                    <p><strong>Area:</strong> Contract Administration - Pricing</p>
                    <p><strong>Contact:</strong> Sobia Khatana</p>

                    <p style={{ marginTop: 10 }}>
                      <strong>Issue:</strong> Analysts update trackers as price changes come in. 
                      This is manual and time-consuming because updates must be made daily at each 
                      stage of a price change event (delegation → submission → activation).
                    </p>

                    <ul>
                      <li>Automation reads the pricing file periodically</li>
                      <li>Identifies new changes and flags required updates</li>
                      <li>Generates a structured document with extracted changes</li>
                      <li>Reduces 30+ hours of manual work per month</li>
                      <li>Uses LLM automation to maintain accuracy</li>
                    </ul>


          
                      <hr />
                      <div style={{ marginTop: 20 }}>
                        <h4 style={{ marginBottom: 10 }}>Process</h4>
          
                        <ol style={{ paddingLeft: 20, lineHeight: "1.6" }}>
                              <li><strong>Download the periodically Price Tracked Excel</strong></li>
                        </ol>
                      </div>
          
                    </div>
                  </Dialog>
          <div className="mb-4 w-100">
            {/* Header */}
            <div className="text-center mb-4" >
              <h3
                className="gradient-text mb-2"
                style={{ fontSize: "2.5rem", fontWeight: "700" }}
              >
                Price Change Tracker <i
                className="pi pi-eye"
                style={{
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "#1e3a8a",
                }}
                onClick={() => setShowHeadingDialog(true)}
              ></i>  
              </h3> 
              <p className="text-center mb-4" style={{ color: "#6c757d" }}>
                Upload your price data file and track price changes across products
              </p>
            </div>

            {/* Upload + Download Buttons */}
            <div className="content-search-container">
              <div className="col-md-6 mx-auto">
                <div className="d-flex justify-content-center gap-3 mb-4">
                  {/* <Button icon="pi pi-upload" className="p-btn btn-sm gap-2" onClick={handleUploadButtonClick}>
                    Upload File
                  </Button> */}

                  <Button icon="pi pi-download" className="p-btn btn-sm gap-2" onClick={handleDownload}>
                    Download
                  </Button>

                  {/* Hidden Input (single file upload) */}
                  <input
                    ref={fileInputRef}
                    type="file"
                    multiple={false}
                    style={{ display: "none" }}
                    accept=".csv,.xlsx"
                    onChange={handleFileChange}
                  />
                </div>

                {selectedFile && (
                  <div className="alert alert-info mt-4 text-center" role="alert">
                    Selected file: {selectedFile.name}
                  </div>
                )}
              </div>
            </div>

            {/* How it works */}
            <div className="content-search-container mt-5">
              <div className="text-center mb-4">
                <h4 className="mb-3" style={{ fontWeight: "600" }}>
                  How It Works
                </h4>
              </div>

              <div className="row justify-content-center">
                {/* <div className="col-md-4 mb-3">
                  <div className="card h-100 text-center border rounded-3">
                    <div className="card-body">
                      <div className="mb-3 fs-1">📤</div>
                      <h6 className="fw-bold">Upload</h6>
                      <small className="text-muted">
                        Upload your price data file
                      </small>
                    </div>
                  </div>
                </div> */}

                <div className="col-md-4 mb-3">
                  <div className="card h-100 text-center border rounded-3">
                    <div className="card-body">
                      <div className="mb-3 fs-1">📊</div>
                      <h6 className="fw-bold">Analyze</h6>
                      <small className="text-muted">
                        Track price changes automatically
                      </small>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="card h-100 text-center border rounded-3">
                    <div className="card-body">
                      <div className="mb-3 fs-1">📥</div>
                      <h6 className="fw-bold">Download</h6>
                      <small className="text-muted">
                        Get detailed reports
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <style jsx>{`
              .min-vh-75 {
                min-height: 75vh;
              }
              .gradient-text {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            `}</style>
          </div>
        </div>
      </div>
    </div>
  );
}

/* 🔥 STYLES */
const styles = {
  wrapper: {
    margin: "5px",
    padding: "5px",
    background: "#f3f4f6",
  },

  headingDialogText: {
    fontSize: 15,
    lineHeight: "1.6",
  },

  resultsSection: {
    background: "white",
    borderRadius: 10,
    padding: 15,
  },

  resultsHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 10,
  },

  resultsTitle: { fontSize: 18 },

  recordCount: {
    padding: "4px 10px",
    background: "#e0f2fe",
    borderRadius: 12,
  },

  dataTable: {
    borderRadius: 8,
  },
};

